<template>
  <div class="leave_setup">
    <div class="leave__loader" v-if="pageloader">
      <div>
        <PageLoader />
      </div>
    </div>
    <div class="leave__error" v-if="errorDiv"></div>
    <div class="leave_assign" v-if="!pageloader">
      <p>We understand your employees levels could have different number of days because of their level. Set it up here.</p>
      <div class="leave_assign__form">
        <div class="leave_assign__form--banner" v-for="(leave, index) in leaveLevels" :key="index">
          <div
            class="leave_assign__form--banner-header"
            @click="showLeaveTab(index)"
          >{{leave.title}}</div>
          <div class="leave_assign__form--banner-body">
            <div v-for="(assign, num) in leave.assignedLeaves" :key="num">
              <div class="leave_assign__form--banner-body-key">{{assign.type}}</div>
              <div class="leave_assign__form--banner-body-value">
                <input type="text" placeholder="Enter number of days" v-model="assign.no_of_days" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="leave_assign__btn">
        <div @click="postLevels" v-if="!buttonLoader">Save</div>
        <div v-if="buttonLoader">
          <WhiteLoader />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../../store/constant";
import PageLoader from "../../partials/page-loader";
import WhiteLoader from "../../partials/white-loader";

export default {
  name: "LeaveAssign",
  components: {
    PageLoader,
    WhiteLoader
  },
  data() {
    return {
      pageloader: true,
      buttonLoader: false,
      selectedTab: null,
      errorDiv: true,
      errorMessage: null,
      leaveLevels: []
    };
  },
  created() {
    this.getLevels();
  },
  methods: {
    getLevels() {
      this.errorDiv = false;
      this.errorMessage = null;

      this.$http
        .get(types.LEAVE_ASSIGN)
        .then(resp => {
          this.leaveLevels = [...resp.data.data];

          this.pageloader = false;
        })
        .catch(err => {
          this.errorDiv = true;
          this.errorMessage = "Server error, Please try again later.";
        });
    },
    postLevels() {
      this.errorDiv = false;
      this.errorMessage = null;
      if (this.selectedTab !== null) {
        this.buttonLoader = true;
        const tab = this.leaveLevels[this.selectedTab];
        const updatedLeave = {
          level_id: tab.id,
          assignedLeaves: []
        };

        for (let index = 0; index < tab.assignedLeaves.length; index++) {
          updatedLeave.assignedLeaves.push({
            leave_type_id: tab.assignedLeaves[index].id,
            no_of_days: tab.assignedLeaves[index].no_of_days
              ? tab.assignedLeaves[index].no_of_days
              : 0
          });
        }

        this.$http
          .post(types.LEAVE_ASSIGN, updatedLeave)
          .then(resp => {
            this.pageloader = true;

            this.getLevels();

            this.buttonLoader = false;
          })
          .catch(err => {
            this.errorDiv = true;
            this.errorMessage = "Server error, Please try again later.";
          });
      }
    },
    showLeaveTab(val) {
      const leaveBody = document.querySelectorAll(
        ".leave_assign__form--banner-body"
      );

      for (let index = 0; index < leaveBody.length; index++) {
        leaveBody[index].style.display = "none";
      }

      document.querySelectorAll(".leave_assign__form--banner-body")[
        val
      ].style.display = "block";

      this.selectedTab = val;
    }
  }
};
</script>
<style lang="scss" scoped>
.leave_setup {
  padding: 20px 0 100px 0;

  > .leave__loader {
    > div {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
      align-content: center;
    }
  }

  > .leave__error {
    border: 1px solid red;
    margin-bottom: 10px;
    padding: 10px;
    background-color: rgba(255, 0, 0, 0.4);
    color: #fff;
    font-size: 14px;
    text-align: left;
  }

  > .leave_assign {
    > p {
      font-size: 16px;
      text-align: left;
      color: #000;
    }

    > .leave_assign__form {
      > .leave_assign__form--banner {
        max-width: 600px;

        > .leave_assign__form--banner-header {
          padding: 10px;
          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
          font-size: 14px;
          color: #000;
          cursor: pointer;
        }

        > .leave_assign__form--banner-body {
          margin: 10px 0 20px 0;
          display: none;

          > div {
            max-width: 400px;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            align-content: center;
            margin-bottom: 10px;

            > .leave_assign__form--banner-body-key {
              font-size: 16px;
              text-align: left;
              color: #000;
              width: 50%;
            }

            > .leave_assign__form--banner-body-value {
              font-size: 16px;
              text-align: left;
              color: #000;
              width: 50%;
              border: 1px solid #000;
              border-radius: 5px;
              overflow: hidden;

              > input {
                height: 40px;
                border: #000;
                outline: 0;
                padding: 0 5px;
                font-size: 14px;
              }
            }
          }
        }
      }
    }

    > .leave_assign__btn {
      margin-top: 50px;
      > div {
        width: 100px;
        height: 40px;
        background-color: #5099de;
        font-size: 14px;
        font-weight: 200;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.67;
        letter-spacing: normal;
        color: #fff;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
        border-radius: 5px;
        cursor: pointer;
      }
    }
  }
}
</style>
